import crypto from 'crypto';

const hashPassword = (plainPassword: string) => {
	const hashedPassword = crypto.createHash('sha256').update(plainPassword).digest('hex');
	return hashedPassword;
};

export default hashPassword;